
<style scoped>
.title {
  font-family: PingFangSC-Semibold;
  font-size: 20px;
  color: #111111;
  letter-spacing: 1.11px;
  text-align: justify;
  font-weight: 549;
}
.wrapUn {
  display: flex;
  flex-direction: column;
}
main {
  flex: 1;
  padding: 10px;
  display: flex;
}
.table {
  overflow: auto;
  flex: 1;
}
</style>

<template>
  <div style="background:#fff;border-radius:10px;height:100%;" class="wrapUn">
    <exportDate
      v-if="showExport"
      :provName="conditon.provName"
      :companyName="companyName"
      @hideExport="hideExport1"
      :moduleName="moduleName"
    />
    <Form
      :conditon="conditon"
      :provinceList="provinceList"
      :title="title"
      :search="search"
      :exportDate="exportDate"
      :prev="prev"
    >
      <Season slot="season" :getValue="getValue" :defaultValue="conditon.time"/>
      <!-- slot='exportData' -->
    </Form>
    <main>
      <Table :tableData="tableData" :name="companyName" :address="address">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          :page-size="20"
          layout="prev, pager, next, jumper"
          :total="total"
          style="text-align: center;padding-top:20px;"
        ></el-pagination>
      </Table>
    </main>
  </div>
</template>
<script>
/**
 * @file:  View 组件 view
 * @author: v_chengmengya
 * @date: 2019-05-16
 * @description: 停靠非石化加油站企业详情
 */
import Form from './components/form' // from表单
import Table from './components/table' // 表格
import Season from '../carUnpetrifiedCom/components/season' // 季度选择
import exportDate from '@/components/exportDate/quarter' // 月份选择
import http from '@/api/freight' // 请求汇总
export default {
  components: {
    Form,
    Table,
    Season,
    exportDate
  },
  data() {
    return {
      title: '企业详情',
      moduleName: 'companyVehicleDetail',
      showExport: false,
      tableData: [], // 表格数据
      conditon: {
        // 表单数据
        time: '',
        isCard: '',
        provName: '',
        range: ''
      },
      provinceList: [], // 省份数据
      currentPage3: 1,
      companyName: '',
      total: 10,
      address: ''
    }
  },
  watch: {
    // 'conditon.data': function(value, oldValue) {
    //   // 父组件监听子组件数据
    //   console.log(value)
    // }
  },
  created() {
    this.companyName = this.$route.query.companyName
      ? this.$route.query.companyName
      : ''
    this.conditon.time = this.$route.query.time ? this.$route.query.time : ''
  },
  methods: {
    //导出
    exportDate() {
      this.showExport = true
    },
    // 取消导出
    hideExport1() {
      this.showExport = false
    },
    initDate() {
      let that = this
      // 初始化数据
      http
        .carUnpetrifiedDetail({
          companyName: that.companyName,
          time: that.conditon.time,
          isCard: that.conditon.isCard,
          provName: that.conditon.provName,
          page: that.currentPage3,
          pageSize: 20
        })
        .then(e => {
          if (e.code == 200 && e.data.tPageUtil && e.data.tPageUtil.list) {
            that.tableData = e.data.tPageUtil.list.slice(0)
            that.total = e.data.tPageUtil.count
            that.address = e.data.companyAddress
          } else {
            that.tableData = e.data.tPageUtil.list
            that.total = e.data.tPageUtil.count
            that.address = e.data.companyAddress
          }
        })
    },
    prev() {
       // 返回上级
      // this.$router.go(-1); 
      this.$router.push({
        name: 'carUnpetrifiedCom'
      })
    },
    getPrev() {
      let that = this
      http.carUnpetrifiedComProv({}).then(e => {
        if (e.code == 200 && e.data) {
          that.provinceList = [...e.data]
        }
      })
    },
    search() {
      this.currentPage3 = 1
      this.initDate()
    },
    handleCurrentChange(index) {
      this.currentPage3 = index
      this.initDate()
    },
    getValue(time) {
      let that = this
      that.conditon.time = time
    }
  },
  mounted() {
    this.getPrev()
    this.initDate()
  }
}
</script>